import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    const button = event.currentTarget
    const attackId = button.dataset.attackId
    
    // Fetch attack details and add to form
    fetch(`/statblocks/attacks/${attackId}`, {
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => response.json())
    .then(attack => {
      // Dispatch custom event with attack data
      const event = new CustomEvent('attack-selected', { 
        detail: { attack },
        bubbles: true 
      })
      this.element.dispatchEvent(event)
    })
  }
} 